
import './email-settings.tag'
import './email-templates.tag'

riot.tag2('email', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#email-templates">Шаблоны</a></li>\n    <li><a data-toggle="tab" href="#email-settings">Настройки</a></li>\n\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="email-templates">\n      <email-templates></email-templates>\n    </div>\n    <div class="tab-pane fade" id="email-settings">\n      <email-settings></email-settings>\n    </div>\n\n  </div>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./pages/settings/email/email.tag